import Staff from "./staff/staff.store";
import Teacher from "./teacher/teacher.store";

export default {
  modules: {
    Staff,
    Teacher,
  },
};
